export default __webpack_public_path__ + "static/media/AreaChartBlue.e8827df9.svg";